export const countries = [
  { value: 'AD', label: 'Andorra', phone: '376', flag: '🇦🇩' },
  { value: 'AE', label: 'United Arab Emirates', phone: '971', flag: '🇦🇪' },
  { value: 'AF', label: 'Afghanistan', phone: '93', flag: '🇦🇫' },
  { value: 'AG', label: 'Antigua and Barbuda', phone: '1-268', flag: '🇦🇬' },
  { value: 'AI', label: 'Anguilla', phone: '1-264', flag: '🇦🇮' },
  { value: 'AL', label: 'Albania', phone: '355', flag: '🇦🇱' },
  { value: 'AM', label: 'Armenia', phone: '374', flag: '🇦🇲' },
  { value: 'AO', label: 'Angola', phone: '244', flag: '🇦🇴' },
  { value: 'AQ', label: 'Antarctica', phone: '672', flag: '🇦🇶' },
  { value: 'AR', label: 'Argentina', phone: '54', flag: '🇦🇷' },
  { value: 'AS', label: 'American Samoa', phone: '1-684', flag: '🇦🇸' },
  { value: 'AT', label: 'Austria', phone: '43', flag: '🇦🇹' },
  { value: 'AU', label: 'Australia', phone: '61', suggested: true, flag: '🇦🇺' },
  { value: 'AW', label: 'Aruba', phone: '297', flag: '🇦🇼' },
  { value: 'AX', label: 'Åland Islands', phone: '358', flag: '🇦🇽' },
  { value: 'AZ', label: 'Azerbaijan', phone: '994', flag: '🇦🇿' },
  { value: 'BA', label: 'Bosnia and Herzegovina', phone: '387', flag: '🇧🇦' },
  { value: 'BB', label: 'Barbados', phone: '1-246', flag: '🇧🇧' },
  { value: 'BD', label: 'Bangladesh', phone: '880', flag: '🇧🇩' },
  { value: 'BE', label: 'Belgium', phone: '32', flag: '🇧🇪' },
  { value: 'BF', label: 'Burkina Faso', phone: '226', flag: '🇧🇫' },
  { value: 'BG', label: 'Bulgaria', phone: '359', flag: '🇧🇬' },
  { value: 'BH', label: 'Bahrain', phone: '973', flag: '🇧🇭' },
  { value: 'BI', label: 'Burundi', phone: '257', flag: '🇧🇮' },
  { value: 'BJ', label: 'Benin', phone: '229', flag: '🇧🇯' },
  { value: 'BL', label: 'Saint Barthélemy', phone: '590', flag: '🇧🇱' },
  { value: 'BM', label: 'Bermuda', phone: '1-441', flag: '🇧🇲' },
  { value: 'BN', label: 'Brunei Darussalam', phone: '673', flag: '🇧🇳' },
  { value: 'BO', label: 'Bolivia', phone: '591', flag: '🇧🇴' },
  { value: 'BR', label: 'Brazil', phone: '55', flag: '🇧🇷' },
  { value: 'BS', label: 'Bahamas', phone: '1-242', flag: '🇧🇸' },
  { value: 'BT', label: 'Bhutan', phone: '975', flag: '🇧🇹' },
  { value: 'BV', label: 'Bouvet Island', phone: '47', flag: '🇧🇻' },
  { value: 'BW', label: 'Botswana', phone: '267', flag: '🇧🇼' },
  { value: 'BY', label: 'Belarus', phone: '375', flag: '🇧🇾' },
  { value: 'BZ', label: 'Belize', phone: '501', flag: '🇧🇿' },
  { value: 'CA', label: 'Canada', phone: '1', suggested: true, flag: '🇨🇦' },
  { value: 'CC', label: 'Cocos (Keeling) Islands', phone: '61', flag: '🇨🇨' },
  {
    value: 'CD',
    label: 'Congo, Democratic Republic of the',
    phone: '243',
    flag: '🇨🇩',
  },
  { value: 'CF', label: 'Central African Republic', phone: '236', flag: '🇨🇫' },
  { value: 'CG', label: 'Congo', phone: '242', flag: '🇨🇬' },
  { value: 'CH', label: 'Switzerland', phone: '41', flag: '🇨🇭' },
  { value: 'CI', label: "Côte d'Ivoire", phone: '225', flag: '🇨🇮' },
  { value: 'CK', label: 'Cook Islands', phone: '682', flag: '🇨🇰' },
  { value: 'CL', label: 'Chile', phone: '56', flag: '🇨🇱' },
  { value: 'CM', label: 'Cameroon', phone: '237', flag: '🇨🇲' },
  { value: 'CN', label: 'China', phone: '86', flag: '🇨🇳' },
  { value: 'CO', label: 'Colombia', phone: '57', flag: '🇨🇴' },
  { value: 'CR', label: 'Costa Rica', phone: '506', flag: '🇨🇷' },
  { value: 'CU', label: 'Cuba', phone: '53', flag: '🇨🇺' },
  { value: 'CV', label: 'Cabo Verde', phone: '238', flag: '🇨🇻' },
  { value: 'CW', label: 'Curaçao', phone: '599', flag: '🇨🇼' },
  { value: 'CX', label: 'Christmas Island', phone: '61', flag: '🇨🇽' },
  { value: 'CY', label: 'Cyprus', phone: '357', flag: '🇨🇾' },
  { value: 'CZ', label: 'Czech Republic', phone: '420', flag: '🇨🇿' },
  { value: 'DE', label: 'Germany', phone: '49', flag: '🇩🇪' },
  { value: 'DJ', label: 'Djibouti', phone: '253', flag: '🇩🇯' },
  { value: 'DK', label: 'Denmark', phone: '45', flag: '🇩🇰' },
  { value: 'DM', label: 'Dominica', phone: '1-767', flag: '🇩🇲' },
  { value: 'DO', label: 'Dominican Republic', phone: '1-809', flag: '🇩🇴' },
  { value: 'DZ', label: 'Algeria', phone: '213', flag: '🇩🇿' },
  { value: 'EC', label: 'Ecuador', phone: '593', flag: '🇪🇨' },
  { value: 'EE', label: 'Estonia', phone: '372', flag: '🇪🇪' },
  { value: 'EG', label: 'Egypt', phone: '20', flag: '🇪🇬' },
  { value: 'EH', label: 'Western Sahara', phone: '212', flag: '🇪🇭' },
  { value: 'ER', label: 'Eritrea', phone: '291', flag: '🇪🇷' },
  { value: 'ES', label: 'Spain', phone: '34', flag: '🇪🇸' },
  { value: 'ET', label: 'Ethiopia', phone: '251', flag: '🇪🇹' },
  { value: 'FI', label: 'Finland', phone: '358', flag: '🇫🇮' },
  { value: 'FJ', label: 'Fiji', phone: '679', flag: '🇫🇯' },
  { value: 'FM', label: 'Micronesia', phone: '691', flag: '🇫🇲' },
  { value: 'FO', label: 'Faroe Islands', phone: '298', flag: '🇫🇴' },
  { value: 'FR', label: 'France', phone: '33', flag: '🇫🇷' },
  { value: 'GA', label: 'Gabon', phone: '241', flag: '🇬🇦' },
  { value: 'GB', label: 'United Kingdom', phone: '44', flag: '🇬🇧' },
  { value: 'GD', label: 'Grenada', phone: '1-473', flag: '🇬🇩' },
  { value: 'GE', label: 'Georgia', phone: '995', flag: '🇬🇪' },
  { value: 'GF', label: 'French Guiana', phone: '594', flag: '🇬🇫' },
  { value: 'GG', label: 'Guernsey', phone: '44', flag: '🇬🇬' },
  { value: 'GH', label: 'Ghana', phone: '233', flag: '🇬🇭' },
  { value: 'GI', label: 'Gibraltar', phone: '350', flag: '🇬🇮' },
  { value: 'GL', label: 'Greenland', phone: '299', flag: '🇬🇱' },
  { value: 'GM', label: 'Gambia', phone: '220', flag: '🇬🇲' },
  { value: 'GN', label: 'Guinea', phone: '224', flag: '🇬🇳' },
  { value: 'GP', label: 'Guadeloupe', phone: '590', flag: '🇬🇵' },
  { value: 'GQ', label: 'Equatorial Guinea', phone: '240', flag: '🇬🇶' },
  { value: 'GR', label: 'Greece', phone: '30', flag: '🇬🇷' },
  { value: 'GT', label: 'Guatemala', phone: '502', flag: '🇬🇹' },
  { value: 'GU', label: 'Guam', phone: '1-671', flag: '🇬🇺' },
  { value: 'GW', label: 'Guinea-Bissau', phone: '245', flag: '🇬🇼' },
  { value: 'GY', label: 'Guyana', phone: '592', flag: '🇬🇾' },
  { value: 'HK', label: 'Hong Kong', phone: '852', flag: '🇭🇰' },
  {
    value: 'HM',
    label: 'Heard Island and McDonald Islands',
    phone: '61',
    flag: '🇭🇲',
  },
  { value: 'HN', label: 'Honduras', phone: '504', flag: '🇭🇳' },
  { value: 'HR', label: 'Croatia', phone: '385', flag: '🇭🇷' },
  { value: 'HT', label: 'Haiti', phone: '509', flag: '🇭🇹' },
  { value: 'HU', label: 'Hungary', phone: '36', flag: '🇭🇺' },
  { value: 'ID', label: 'Indonesia', phone: '62', flag: '🇮🇩' },
  { value: 'IE', label: 'Ireland', phone: '353', flag: '🇮🇪' },
  { value: 'IM', label: 'Isle of Man', phone: '44', flag: '🇮🇲' },
  { value: 'IN', label: 'India', phone: '91', flag: '🇮🇳' },
  {
    value: 'IO',
    label: 'British Indian Ocean Territory',
    phone: '246',
    flag: '🇮🇴',
  },
  { value: 'IQ', label: 'Iraq', phone: '964', flag: '🇮🇶' },
  { value: 'IR', label: 'Iran', phone: '98', flag: '🇮🇷' },
  { value: 'IS', label: 'Iceland', phone: '354', flag: '🇮🇸' },
  { value: 'IT', label: 'Italy', phone: '39', flag: '🇮🇹' },
  { value: 'JE', label: 'Jersey', phone: '44', flag: '🇯🇪' },
  { value: 'JM', label: 'Jamaica', phone: '1-876', flag: '🇯🇲' },
  { value: 'JO', label: 'Jordan', phone: '962', flag: '🇯🇴' },
  { value: 'JP', label: 'Japan', phone: '81', flag: '🇯🇵' },
  { value: 'KE', label: 'Kenya', phone: '254', flag: '🇰🇪' },
  { value: 'KG', label: 'Kyrgyzstan', phone: '996', flag: '🇰🇬' },
  { value: 'KH', label: 'Cambodia', phone: '855', flag: '🇰🇭' },
  { value: 'KI', label: 'Kiribati', phone: '686', flag: '🇰🇮' },
  { value: 'KM', label: 'Comoros', phone: '269', flag: '🇰🇲' },
  { value: 'KN', label: 'Saint Kitts and Nevis', phone: '1-869', flag: '🇰🇳' },
  { value: 'KP', label: 'North Korea', phone: '850', flag: '🇰🇵' },
  { value: 'KR', label: 'South Korea', phone: '82', flag: '🇰🇷' },
  { value: 'KW', label: 'Kuwait', phone: '965', flag: '🇰🇼' },
  { value: 'KY', label: 'Cayman Islands', phone: '1-345', flag: '🇰🇾' },
  { value: 'KZ', label: 'Kazakhstan', phone: '7', flag: '🇰🇿' },
  { value: 'LA', label: 'Laos', phone: '856', flag: '🇱🇦' },
  { value: 'LB', label: 'Lebanon', phone: '961', flag: '🇱🇧' },
  { value: 'LC', label: 'Saint Lucia', phone: '1-758', flag: '🇱🇨' },
  { value: 'LI', label: 'Liechtenstein', phone: '423', flag: '🇱🇮' },
  { value: 'LK', label: 'Sri Lanka', phone: '94', flag: '🇱🇰' },
  { value: 'LR', label: 'Liberia', phone: '231', flag: '🇱🇷' },
  { value: 'LS', label: 'Lesotho', phone: '266', flag: '🇱🇸' },
  { value: 'LT', label: 'Lithuania', phone: '370', flag: '🇱🇹' },
  { value: 'LU', label: 'Luxembourg', phone: '352', flag: '🇱🇺' },
  { value: 'LV', label: 'Latvia', phone: '371', flag: '🇱🇻' },
  { value: 'LY', label: 'Libya', phone: '218', flag: '🇱🇾' },
  { value: 'MA', label: 'Morocco', phone: '212', flag: '🇲🇦' },
  { value: 'MC', label: 'Monaco', phone: '377', flag: '🇲🇨' },
  { value: 'MD', label: 'Moldova', phone: '373', flag: '🇲🇩' },
  { value: 'ME', label: 'Montenegro', phone: '382', flag: '🇲🇪' },
  { value: 'MF', label: 'Saint Martin', phone: '590', flag: '🇲🇫' },
  { value: 'MG', label: 'Madagascar', phone: '261', flag: '🇲🇬' },
  { value: 'MH', label: 'Marshall Islands', phone: '692', flag: '🇲🇭' },
  { value: 'MK', label: 'North Macedonia', phone: '389', flag: '🇲🇰' },
  { value: 'ML', label: 'Mali', phone: '223', flag: '🇲🇱' },
  { value: 'MM', label: 'Myanmar', phone: '95', flag: '🇲🇲' },
  { value: 'MN', label: 'Mongolia', phone: '976', flag: '🇲🇳' },
  { value: 'MO', label: 'Macao', phone: '853', flag: '🇲🇴' },
  {
    value: 'MP',
    label: 'Northern Mariana Islands',
    phone: '1-670',
    flag: '🇲🇵',
  },
  { value: 'MQ', label: 'Martinique', phone: '596', flag: '🇲🇶' },
  { value: 'MR', label: 'Mauritania', phone: '222', flag: '🇲🇷' },
  { value: 'MS', label: 'Montserrat', phone: '1-664', flag: '🇲🇸' },
  { value: 'MT', label: 'Malta', phone: '356', flag: '🇲🇹' },
  { value: 'MU', label: 'Mauritius', phone: '230', flag: '🇲🇺' },
  { value: 'MV', label: 'Maldives', phone: '960', flag: '🇲🇻' },
  { value: 'MW', label: 'Malawi', phone: '265', flag: '🇲🇼' },
  { value: 'MX', label: 'Mexico', phone: '52', flag: '🇲🇽' },
  { value: 'MY', label: 'Malaysia', phone: '60', flag: '🇲🇾' },
  { value: 'MZ', label: 'Mozambique', phone: '258', flag: '🇲🇿' },
  { value: 'NA', label: 'Namibia', phone: '264', flag: '🇳🇦' },
  { value: 'NC', label: 'New Caledonia', phone: '687', flag: '🇳🇨' },
  { value: 'NE', label: 'Niger', phone: '227', flag: '🇳🇪' },
  { value: 'NF', label: 'Norfolk Island', phone: '672', flag: '🇳🇫' },
  { value: 'NG', label: 'Nigeria', phone: '234', flag: '🇳🇬' },
  { value: 'NI', label: 'Nicaragua', phone: '505', flag: '🇳🇮' },
  { value: 'NL', label: 'Netherlands', phone: '31', flag: '🇳🇱' },
  { value: 'NO', label: 'Norway', phone: '47', flag: '🇳🇴' },
  { value: 'NP', label: 'Nepal', phone: '977', flag: '🇳🇵' },
  { value: 'NR', label: 'Nauru', phone: '674', flag: '🇳🇷' },
  { value: 'NU', label: 'Niue', phone: '683', flag: '🇳🇺' },
  { value: 'NZ', label: 'New Zealand', phone: '64', flag: '🇳🇿' },
  { value: 'OM', label: 'Oman', phone: '968', flag: '🇴🇲' },
  { value: 'PA', label: 'Panama', phone: '507', flag: '🇵🇦' },
  { value: 'PE', label: 'Peru', phone: '51', flag: '🇵🇪' },
  { value: 'PF', label: 'French Polynesia', phone: '689', flag: '🇵🇫' },
  { value: 'PG', label: 'Papua New Guinea', phone: '675', flag: '🇵🇬' },
  { value: 'PH', label: 'Philippines', phone: '63', flag: '🇵🇭' },
  { value: 'PK', label: 'Pakistan', phone: '92', flag: '🇵🇰' },
  { value: 'PL', label: 'Poland', phone: '48', flag: '🇵🇱' },
  { value: 'PM', label: 'Saint Pierre and Miquelon', phone: '508', flag: '🇵🇲' },
  { value: 'PN', label: 'Pitcairn Islands', phone: '870', flag: '🇵🇳' },
  { value: 'PR', label: 'Puerto Rico', phone: '1-787', flag: '🇵🇷' },
  { value: 'PT', label: 'Portugal', phone: '351', flag: '🇵🇹' },
  { value: 'PW', label: 'Palau', phone: '680', flag: '🇵🇼' },
  { value: 'PY', label: 'Paraguay', phone: '595', flag: '🇵🇾' },
  { value: 'QA', label: 'Qatar', phone: '974', flag: '🇶🇦' },
  { value: 'RE', label: 'Réunion', phone: '262', flag: '🇷🇪' },
  { value: 'RO', label: 'Romania', phone: '40', flag: '🇷🇴' },
  { value: 'RS', label: 'Serbia', phone: '381', flag: '🇷🇸' },
  { value: 'RU', label: 'Russia', phone: '7', flag: '🇷🇺' },
  { value: 'RW', label: 'Rwanda', phone: '250', flag: '🇷🇼' },
  { value: 'SA', label: 'Saudi Arabia', phone: '966', flag: '🇸🇦' },
  { value: 'SB', label: 'Solomon Islands', phone: '677', flag: '🇸🇧' },
  { value: 'SC', label: 'Seychelles', phone: '248', flag: '🇸🇨' },
  { value: 'SD', label: 'Sudan', phone: '249', flag: '🇸🇩' },
  { value: 'SE', label: 'Sweden', phone: '46', flag: '🇸🇪' },
  { value: 'SG', label: 'Singapore', phone: '65', flag: '🇸🇬' },
  { value: 'SH', label: 'Saint Helena', phone: '290', flag: '🇸🇭' },
  { value: 'SI', label: 'Slovenia', phone: '386', flag: '🇸🇮' },
  { value: 'SJ', label: 'Svalbard and Jan Mayen', phone: '47', flag: '🇸🇯' },
  { value: 'SK', label: 'Slovakia', phone: '421', flag: '🇸🇰' },
  { value: 'SL', label: 'Sierra Leone', phone: '232', flag: '🇸🇱' },
  { value: 'SM', label: 'San Marino', phone: '378', flag: '🇸🇲' },
  { value: 'SN', label: 'Senegal', phone: '221', flag: '🇸🇳' },
  { value: 'SO', label: 'Somalia', phone: '252', flag: '🇸🇴' },
  { value: 'SR', label: 'Suriname', phone: '597', flag: '🇸🇷' },
  { value: 'SS', label: 'South Sudan', phone: '211', flag: '🇸🇸' },
  { value: 'ST', label: 'São Tomé and Príncipe', phone: '239', flag: '🇸🇹' },
  { value: 'SV', label: 'El Salvador', phone: '503', flag: '🇸🇻' },
  { value: 'SX', label: 'Sint Maarten', phone: '1-721', flag: '🇸🇽' },
  { value: 'SY', label: 'Syria', phone: '963', flag: '🇸🇾' },
  { value: 'SZ', label: 'Eswatini', phone: '268', flag: '🇸🇿' },
  {
    value: 'TC',
    label: 'Turks and Caicos Islands',
    phone: '1-649',
    flag: '🇹🇨',
  },
  { value: 'TD', label: 'Chad', phone: '235', flag: '🇹🇩' },
  {
    value: 'TF',
    label: 'French Southern and Antarctic Lands',
    phone: '262',
    flag: '🇹🇫',
  },
  { value: 'TG', label: 'Togo', phone: '228', flag: '🇹🇬' },
  { value: 'TH', label: 'Thailand', phone: '66', flag: '🇹🇭' },
  { value: 'TJ', label: 'Tajikistan', phone: '992', flag: '🇹🇯' },
  { value: 'TK', label: 'Tokelau', phone: '690', flag: '🇹🇰' },
  { value: 'TL', label: 'East Timor', phone: '670', flag: '🇹🇱' },
  { value: 'TM', label: 'Turkmenistan', phone: '993', flag: '🇹🇲' },
  { value: 'TN', label: 'Tunisia', phone: '216', flag: '🇹🇳' },
  { value: 'TO', label: 'Tonga', phone: '676', flag: '🇹🇴' },
  { value: 'TR', label: 'Turkey', phone: '90', flag: '🇹🇷' },
  { value: 'TT', label: 'Trinidad and Tobago', phone: '1-868', flag: '🇹🇹' },
  { value: 'TV', label: 'Tuvalu', phone: '688', flag: '🇹🇻' },
  { value: 'TZ', label: 'Tanzania', phone: '255', flag: '🇹🇿' },
  { value: 'UA', label: 'Ukraine', phone: '380', flag: '🇺🇦' },
  { value: 'UG', label: 'Uganda', phone: '256', flag: '🇺🇬' },
  { value: 'US', label: 'United States', phone: '1', flag: '🇺🇸' },
  { value: 'UY', label: 'Uruguay', phone: '598', flag: '🇺🇾' },
  { value: 'UZ', label: 'Uzbekistan', phone: '998', flag: '🇺🇿' },
  { value: 'VA', label: 'Vatican City', phone: '379', flag: '🇻🇦' },
  {
    value: 'VC',
    label: 'Saint Vincent and the Grenadines',
    phone: '1-784',
    flag: '🇻🇨',
  },
  { value: 'VE', label: 'Venezuela', phone: '58', flag: '🇻🇪' },
  { value: 'VG', label: 'British Virgin Islands', phone: '1-284', flag: '🇻🇬' },
  { value: 'VI', label: 'U.S. Virgin Islands', phone: '1-340', flag: '🇻🇮' },
  { value: 'VN', label: 'Vietnam', phone: '84', flag: '🇻🇳' },
  { value: 'VU', label: 'Vanuatu', phone: '678', flag: '🇻🇺' },
  { value: 'WF', label: 'Wallis and Futuna', phone: '681', flag: '🇼🇫' },
  { value: 'WS', label: 'Samoa', phone: '685', flag: '🇼🇸' },
  { value: 'YE', label: 'Yemen', phone: '967', flag: '🇾🇪' },
  { value: 'YT', label: 'Mayotte', phone: '262', flag: '🇾🇹' },
  { value: 'ZA', label: 'South Africa', phone: '27', flag: '🇿🇦' },
  { value: 'ZM', label: 'Zambia', phone: '260', flag: '🇿🇲' },
  { value: 'ZW', label: 'Zimbabwe', phone: '263', flag: '🇿🇼' },
];
